import { A4uDeleteOutline as IconComponent } from '@adobe/react-spectrum-workflow/dist/DeleteOutline.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function DeleteOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}